import { creator } from '@helpers/httpMethods'
import { publicIp } from 'public-ip'

declare const ttq: any

const TRACKING_ID = process.env.NEXT_PUBLIC_TT_PIXEL

const trackPageView = () => {
  if (process.env.NEXT_PUBLIC_VERCEL_ENV == 'production') {
    ttq.page()
  }
}

const trackEvent = async (
  eventName: string,
  params?: { email?: string; data?: unknown }
) => {
  if (process.env.NEXT_PUBLIC_VERCEL_ENV == 'production') {
    const ip = await publicIp()

    const eventID = Date.now()

    ttq.track(eventName, { event_id: eventID })

    await creator({
      url: '/api/tiktok/events',
      body: {
        eventName,
        eventID,
        email: params?.email,
        url: window.location.href,
        ip: ip,
        data: params?.data
      }
    })
  }
}

const trackPurchase = async ({
  email,
  currency,
  value
}: {
  email: string
  currency: string
  value: number
}) => {
  if (process.env.NEXT_PUBLIC_VERCEL_ENV == 'production') {
    const ip = await publicIp()

    const eventID = Date.now()

    ttq.track('CompletePayment', { currency, value, event_id: eventID })

    await creator({
      url: '/api/tiktok/events',
      body: {
        eventName: 'CompletePayment',
        eventID,
        email,
        url: window.location.href,
        ip: ip,
        data: {
          currency,
          value
        }
      }
    })
  }
}

const ttpixel = { TRACKING_ID, trackPageView, trackEvent, trackPurchase }

export default ttpixel
